// 国际化简体中文表达部分
export default {
  common: {
    zoom: "缩放",
    focalLength: "焦距",
    monitoringList: "监控列表",
    cloudPortal: "萤石云入口",
    confirm: "确认",
    cancel: "取消",
    screenshotConfirm: "截图确认",
    jumpConfirm: "跳转确认",
  },
  player: {
    ptz_top_bottom: "该设备不支持上下转动",
    ptz_left_right: "该设备不支持左右转动",
    ptz_zoom: "该设备不支持缩放控制",
    ptz_focus: "该设备不支持焦距模式 ",
  },
  warning: {
    noVideo: "暂无视频",
    underDevelopment: "该功能正在开发，敬请期待！",
    noPermission: "抱歉，您暂无操作权限!",
  },
  tips: {
    saveScreenshot: "是否保存截图到本地(需返回上一页面)？",
    jumpToCloud: "确定跳转到萤石云么？",
  }
};
